<template>
  <div class="camera_wrap" id="slide" ref="slide">

      <div v-for="(item,index) in banner" :data-src="item.picture"></div>
     <!--  <div :data-src="require('@/assets/temp/2.jpg')"></div>
      <div :data-src="require('@/assets/temp/3.jpg')"></div>   -->

  </div>
</template>

<script>

export default {
  name: 'slide',
  props:{},
  data(){
    return {
      banner:this.$store.state.index.banner
    }
  },
  computed:{
    // banner(){return this.$store.state.index.banner}
  },
  mounted(){
    console.log('slide mounted');
  },
  created(){
  //'curtainTopLeft', 'curtainTopRight', 'curtainBottomLeft', 'curtainBottomRight', 'curtainSliceLeft', 'curtainSliceRight', 'blindCurtainTopLeft', 'blindCurtainTopRight', 'blindCurtainBottomLeft', 'blindCurtainBottomRight', 'blindCurtainSliceBottom', 'blindCurtainSliceTop', 'stampede', 'mosaic', 'mosaicReverse', 'mosaicRandom', 'mosaicSpiral', 'mosaicSpiralReverse', 'topLeftBottomRight', 'bottomRightTopLeft', 'bottomLeftTopRight', 'bottomLeftTopRight'
    console.log('slide created');
    if(this.banner.length===0){
      this.$store.dispatch('index/getBanner').then(res=>{
        console.log(res);
        this.banner = res;
        this.init();
      })
    }else{
      this.init();
    }
  },
  methods:{
    init(){
      this.$nextTick(function () {
        setTimeout(()=>{
          $('#slide').camera({
            time:1000,
            loaderOpacity:0,
            fx:'mosaic'
          });
        },100);
      }); 
    }
  },
  watch:{
    banner:function(val){
      console.log("slide watch");
    }
  }
}
</script>

<style>


@media (max-width: 991px){

}
</style>

